"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomToaster = void 0;

var _ = require("../..");

var _react = _interopRequireWildcard(require("react"));

require("./BottomToaster.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Bottom Toaster
var BottomToaster = /*#__PURE__*/function (_Component) {
  _inherits(BottomToaster, _Component);

  var _super = _createSuper(BottomToaster);

  function BottomToaster(props) {
    var _this;

    _classCallCheck(this, BottomToaster);

    _this = _super.call(this, props);
    _this.state = {
      step: 'start'
    };
    _this.timeouts = [];
    _this.handleCloseOnClick = _this.handleCloseOnClick.bind(_assertThisInitialized(_this));
    _this.handleLinkOnClick = _this.handleLinkOnClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BottomToaster, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.show && this.props.message) {
        var t1 = setTimeout(function () {
          _this2.setState({
            step: 'in'
          });
        }, 30);
        this.timeouts.push(t1);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (!prevProps.show && this.props.show === true && this.props.message) {
        var t1 = setTimeout(function () {
          _this3.setState({
            step: 'in'
          });
        }, 30);
        this.timeouts.push(t1);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      while (this.timeouts.length > 0) {
        if (typeof this.props.onClearMessage === "function") {
          this.props.onClearMessage();
        }

        try {
          for (var i = 0; i < this.timeouts.length; i++) {
            var to = this.timeouts[i];
            clearTimeout(to);
          }
        } catch (err) {
          console.log('Err clearing BottomToaster timeout');
        }
      }
    }
  }, {
    key: "handleLinkOnClick",
    value: function handleLinkOnClick() {
      if (_typeof(this.props.link) && this.props.history) {
        this.props.history.push({
          pathname: this.props.link,
          state: this.props.linkState
        });
      }

      this.setState({
        step: 'out'
      });

      if (typeof this.props.onClearMessage === "function") {
        this.props.onClearMessage();
      }
    }
  }, {
    key: "handleCloseOnClick",
    value: function handleCloseOnClick() {
      this.setState({
        step: 'out'
      });

      if (typeof this.props.onClearMessage === "function") {
        this.props.onClearMessage();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var toastClass = 'BottomToaster';

      if (this.state.step === 'in') {
        toastClass += ' in';
      }

      if (!this.props.link) toastClass += ' no-link';else if (this.state.step === 'out') {
        toastClass += ' out';
      }
      if (!this.props.show) return null;
      return /*#__PURE__*/_react.default.createElement(_.Element, {
        className: toastClass
      }, /*#__PURE__*/_react.default.createElement(_.Row, {
        className: "top-row",
        alignItems: "center",
        justifyContent: "space-between"
      }, this.props.message && /*#__PURE__*/_react.default.createElement("p", {
        onClick: function onClick(e) {
          return _this4.handleCloseOnClick();
        },
        className: "toast-message",
        dangerouslySetInnerHTML: {
          __html: this.props.message
        }
      }), /*#__PURE__*/_react.default.createElement(_.RoundButton, {
        trkAction: "Close Pressed",
        className: "mobile-close-button",
        icon: _.Icon.Type.Close,
        backgroundColor: _.Color.Transparent,
        iconColor: _.Color.Grey3,
        iconSize: 20,
        onClick: this.handleCloseOnClick,
        width: 32,
        height: 32
      })), this.props.link && /*#__PURE__*/_react.default.createElement(_.Button, {
        small: true,
        className: "toast-button",
        onClick: this.handleLinkOnClick,
        content: this.props.linkText,
        backgroundColor: _.Color.TraceTint1,
        color: _.Color.TraceShade1,
        borderRadius: "14"
      }), /*#__PURE__*/_react.default.createElement(_.RoundButton, {
        trkAction: "Close Pressed",
        className: "desktop-close-button",
        icon: _.Icon.Type.Close,
        backgroundColor: _.Color.Transparent,
        iconColor: _.Color.Grey3,
        iconSize: 24,
        onClick: this.handleCloseOnClick,
        width: 40,
        height: "auto"
      }));
    }
  }]);

  return BottomToaster;
}(_react.Component);

exports.BottomToaster = BottomToaster;